package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
fun EmptyContent(
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color,
    content: @Composable () -> Unit
) {
    Column(
        modifier = Modifier.fillMaxWidth()
            .padding(top = dimension.spacing.space5)
            .background(color.surface.normal)
    ) {
        HorizontalDivider(
            modifier = Modifier.fillMaxWidth(),
            color = color.border.subtle
        )
        Column(
            modifier = Modifier.fillMaxWidth()
                .padding(
                    vertical = dimension.spacing.space5,
                    horizontal = dimension.spacing.space4
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            content()
        }
        HorizontalDivider(
            modifier = Modifier.fillMaxWidth(),
            color = color.border.subtle
        )
    }
}
